import { getTimezoneOffset } from "~/utils";
import { ReportRequest } from "./interfaces";

export const getRangeKey = (start: Date, end: Date) => {
    const sy = start.getFullYear();
    const sm = start.getMonth().toString().padStart(2, "0");
    const ey = end.getFullYear();
    const em = end.getMonth().toString().padStart(2, "0");

    return `${sy}.${sm}-${ey}.${em}`;
};

export const getUserRangeKey = (user: string, start: Date, end: Date) => {
    return `${user}-${getRangeKey(start, end)}`;
};

export const getRelation = (relation: ReportRequest["relation"]) => {
    if (!relation) {
        return undefined;
    }

    if ("parentId" in relation) {
        return {
            $case: "time_parent",
            time_parent: relation.parentId,
        } as const;
    }

    if ("calendarId" in relation) {
        return {
            $case: "event",
            event: {
                calendar_id: relation.calendarId,
                event_id: relation.eventId,
                service: relation.service,
            },
        } as const;
    }

    return {
        $case: "track",
        track: relation.trackId,
    } as const;
};

export const getReportStart = (date: Date, onlyDuration?: boolean) => {
    if (onlyDuration === true) {
        return 0;
    }

    const dayStart = new Date(date).setHours(0, 0, 0, 0);
    const utcOffset = getTimezoneOffset("UTC");
    const seconds = (date.getTime() - dayStart + utcOffset) / 1000 || 1; // to avoid 0, as it's a value indicating that the report has no start time

    return seconds;
};
